import st from './Community.module.scss'
import logoType1 from 'assets/images/logo-1.png'
import logoType2 from 'assets/images/logo-2.png'

export const Community = ()=> {
    const { community, title, logo, block, right, flex } = st

    return (
        <section className={community}>
            <div className="wrapper">
                <h2 className={title}>ВСЕГДА НА СВЯЗИ</h2>

                <div className={flex}>
                    <div className={block}>
                        <div className={logo}>
                            <picture>
                                <img src={logoType1} alt="" width={112} height={112} />
                            </picture>
                        </div>
                        <div className={right}>
                            <a href="https://vk.com/jd_er" target={"_blank"} rel="noopener noreferrer">
                                https://vk.com/jd_er
                            </a>
                        </div>
                    </div>
                    <div className={block}>
                        <div className={logo}>
                            <picture>
                                <img src={logoType2} alt="" width={112} height={112} />
                            </picture>
                        </div>
                        <div className={right}>
                            <a href="mailto:jendvijenie@mail.ru">
                                jendvijenie@mail.ru
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
